import { useMutation } from "@tanstack/react-query";
import { sendTestEmailNotification } from "app/api/job_api";

const useSendTestEmailNotification = ({ onSuccess, onError }) => {
  return useMutation({
    mutationFn: ({ jobId, toEmail, updatedBy }) =>
      sendTestEmailNotification(jobId, toEmail, updatedBy),
    onSuccess: onSuccess,
    onError: onError
  });
};

export default useSendTestEmailNotification;
